if (!window.__cartIconGuardAdded) {
  window.__cartIconGuardAdded = true;

  // Something on this store (a third-party app script, not part of this
  // theme) rewrites every number inside the header cart icon's SVG markup
  // shortly after load -- and again after cart updates -- with the cart's
  // current item count. That corrupts width/height/viewBox/path data and
  // makes the icon render as a solid blob instead of the cart outline.
  // This watches the icon and repairs it back to the known-good markup
  // whenever that happens, regardless of what causes it.
  var CART_ICON_SVG_MARKUP =
    '<svg class="icon icon-cart" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<rect x="1.75" y="5.75" width="16.5" height="11.5" stroke="currentColor" stroke-width="1.5"/>' +
    '<path d="M14 9V5C14 2.79086 12.2091 1 10 1V1C7.79086 1 6 2.79086 6 5V9" stroke="currentColor" stroke-width="1.5"/>' +
    '</svg>';

  function parseSvg(markup) {
    var template = document.createElement('template');
    template.innerHTML = markup;
    return template.content.firstElementChild;
  }

  function isBrokenSvg(svg) {
    return !svg || svg.getAttribute('viewBox') !== '0 0 20 20';
  }

  function guardCartIcon() {
    var wrapper = document.getElementById('cart-icon-bubble');
    if (!wrapper) return;

    var fixing = false;

    function check() {
      if (fixing) return;
      var svg = wrapper.querySelector('svg.icon-cart');
      if (!isBrokenSvg(svg)) return;

      fixing = true;
      var freshSvg = parseSvg(CART_ICON_SVG_MARKUP);
      if (svg) {
        svg.replaceWith(freshSvg);
      } else {
        var iconWrapper = wrapper.querySelector('.cart-count-bubble__icon');
        if (iconWrapper) iconWrapper.appendChild(freshSvg);
      }
      fixing = false;
    }

    check();

    var observer = new MutationObserver(function () {
      check();
    });
    observer.observe(wrapper, { childList: true, subtree: true, attributes: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guardCartIcon);
  } else {
    guardCartIcon();
  }
}
